import { render } from "./ConfigureSamlSsoAuth.vue?vue&type=template&id=54d2c28b&scoped=true"
import script from "./ConfigureSamlSsoAuth.vue?vue&type=script&lang=js"
export * from "./ConfigureSamlSsoAuth.vue?vue&type=script&lang=js"

import "./ConfigureSamlSsoAuth.vue?vue&type=style&index=0&id=54d2c28b&scoped=true&lang=less"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d2c28b"]])

export default __exports__